module.exports = __webpack_public_path__ + "static/media/indent.ef5a7b7b.svg";